/* ============================================================
   AVALNA PDP CORE — Batch 02a
   Bundled IIFE for: video, zoom, care accordion, size guide.
   All selectors use avalna- namespace.
   ============================================================ */
(function () {
  'use strict';

  /* --- Namespace --- */
  window.Avalna = window.Avalna || {};
  window.Avalna.pdp = { video: {}, zoom: {}, care: {}, sizeGuide: {} };

  /* ============================
     FEATURE: Care Accordion
     ============================ */
  var AvalnaCareMod = window.Avalna.pdp.care;

  /* Unified accordion toggle — Batch 12a
     Handles both "Product Details" (specs) and "Care Instructions" accordions. */
  AvalnaCareMod.init = function () {
    document.querySelectorAll('.avalna-pdp-accordion-header').forEach(function (avalnaHeader) {
      avalnaHeader.addEventListener('click', function () {
        var avalnaAccordion = this.closest('.avalna-pdp-accordion');
        var avalnaBody = avalnaAccordion.querySelector('.avalna-pdp-accordion-body');
        var avalnaIcon = avalnaAccordion.querySelector('.avalna-pdp-accordion-icon');
        var avalnaIsOpen = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!avalnaIsOpen));
        if (avalnaIsOpen) {
          avalnaBody.setAttribute('hidden', '');
          avalnaIcon.textContent = '+';
        } else {
          avalnaBody.removeAttribute('hidden');
          avalnaIcon.textContent = '\u00d7';
        }
      });
    });
  };

  /* ============================
     FEATURE: Size Guide — Batch 19
     Bottom sheet (mobile) + centered modal (desktop).
     Swipe-to-dismiss on mobile, variant-reactive active card.
     ============================ */
  var AvalnaSizeGuideMod = window.Avalna.pdp.sizeGuide;

  AvalnaSizeGuideMod.init = function () {
    var avalnaOpenBtns = document.querySelectorAll('[data-avalna-size-guide-open]');
    var avalnaOverlay = document.getElementById('avalna-pdp-size-guide-overlay');
    if (!avalnaOverlay) return;

    /* Move overlay to body so position:fixed isn't clipped by Dawn's
       containing block (transform/will-change on product section). */
    document.body.appendChild(avalnaOverlay);

    var avalnaPanel = avalnaOverlay.querySelector('[data-avalna-size-guide-panel]');
    var avalnaBackdrop = avalnaOverlay.querySelector('.avalna-pdp-size-guide__backdrop');
    var avalnaCloseBtn = avalnaOverlay.querySelector('[data-avalna-size-guide-close]');
    var avalnaCards = avalnaOverlay.querySelector('[data-avalna-size-guide-cards]');

    /* --- Open / Close --- */
    function avalnaOpenSizeGuide() {
      avalnaOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (avalnaCloseBtn) avalnaCloseBtn.focus();
    }

    function avalnaCloseSizeGuide() {
      if (avalnaPanel) {
        avalnaPanel.style.transform = '';
        avalnaPanel.style.transition = '';
      }
      avalnaOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    avalnaOpenBtns.forEach(function (avalnaBtn) {
      avalnaBtn.addEventListener('click', avalnaOpenSizeGuide);
    });

    if (avalnaCloseBtn) {
      avalnaCloseBtn.addEventListener('click', avalnaCloseSizeGuide);
    }

    if (avalnaBackdrop) {
      avalnaBackdrop.addEventListener('click', avalnaCloseSizeGuide);
    }

    document.addEventListener('keydown', function (avalnaEvt) {
      if (avalnaEvt.key === 'Escape' && avalnaOverlay.getAttribute('aria-hidden') === 'false') {
        avalnaCloseSizeGuide();
      }
    });

    /* --- Swipe-to-dismiss (mobile only) --- */
    if (avalnaPanel) {
      var avalnaTouchStartY = 0;
      var avalnaTouchDeltaY = 0;
      var avalnaIsSwiping = false;
      var AVALNA_SWIPE_THRESHOLD = 80;

      avalnaPanel.addEventListener('touchstart', function (avalnaEvt) {
        if (avalnaPanel.scrollTop > 0) return;
        avalnaTouchStartY = avalnaEvt.touches[0].clientY;
        avalnaTouchDeltaY = 0;
        avalnaIsSwiping = true;
        avalnaPanel.style.transition = 'none';
      }, { passive: true });

      avalnaPanel.addEventListener('touchmove', function (avalnaEvt) {
        if (!avalnaIsSwiping) return;
        avalnaTouchDeltaY = avalnaEvt.touches[0].clientY - avalnaTouchStartY;
        if (avalnaTouchDeltaY < 0) avalnaTouchDeltaY = 0;
        if (avalnaTouchDeltaY > 0) {
          avalnaPanel.style.transform = 'translateY(' + avalnaTouchDeltaY + 'px)';
        }
      }, { passive: true });

      avalnaPanel.addEventListener('touchend', function () {
        if (!avalnaIsSwiping) return;
        avalnaIsSwiping = false;
        avalnaPanel.style.transition = '';
        if (avalnaTouchDeltaY > AVALNA_SWIPE_THRESHOLD) {
          avalnaCloseSizeGuide();
        } else {
          avalnaPanel.style.transform = '';
        }
      }, { passive: true });
    }

    /* --- Variant-reactive active card highlight --- */
    function avalnaUpdateActiveCard(avalnaSelectedSize) {
      if (!avalnaCards) return;
      var avalnaAllCards = avalnaCards.querySelectorAll('[data-avalna-size-guide-size]');
      avalnaAllCards.forEach(function (avalnaCard) {
        if (avalnaCard.getAttribute('data-avalna-size-guide-size') === avalnaSelectedSize) {
          avalnaCard.classList.add('avalna-pdp-size-guide__card--active');
        } else {
          avalnaCard.classList.remove('avalna-pdp-size-guide__card--active');
        }
      });
    }

    /* Listen for Dawn's PubSub variant change events */
    if (window.Shopify && window.Shopify.PubSub) {
      window.Shopify.PubSub.subscribe('variant:change', function (avalnaEvt) {
        if (avalnaEvt && avalnaEvt.variant && avalnaEvt.variant.options) {
          var avalnaProductEl = document.querySelector('[data-product-id]');
          var avalnaProductOptions = null;
          try {
            avalnaProductOptions = JSON.parse(
              document.querySelector('[type="application/json"][data-product-json]')?.textContent || '{}'
            );
          } catch (e) { /* ignore */ }
          var avalnaOptions = avalnaProductOptions && avalnaProductOptions.options ? avalnaProductOptions.options : [];
          for (var i = 0; i < avalnaOptions.length; i++) {
            if (avalnaOptions[i].toLowerCase() === 'size') {
              avalnaUpdateActiveCard(avalnaEvt.variant.options[i]);
              break;
            }
          }
        }
      });
    }

    /* Fallback: listen for variant selector clicks in Dawn's native UI */
    document.addEventListener('change', function (avalnaEvt) {
      var avalnaTarget = avalnaEvt.target;
      if (avalnaTarget && avalnaTarget.name && avalnaTarget.name.toLowerCase().indexOf('size') !== -1) {
        avalnaUpdateActiveCard(avalnaTarget.value);
      }
    });

    /* Also listen for Dawn's variant:change custom event on fieldsets */
    document.addEventListener('click', function (avalnaEvt) {
      var avalnaInput = avalnaEvt.target.closest('input[type="radio"]');
      if (!avalnaInput) return;
      var avalnaFieldset = avalnaInput.closest('fieldset');
      if (!avalnaFieldset) return;
      var avalnaLegend = avalnaFieldset.querySelector('legend');
      if (avalnaLegend && avalnaLegend.textContent.toLowerCase().indexOf('size') !== -1) {
        avalnaUpdateActiveCard(avalnaInput.value);
      }
    });
  };

  /* ============================
     FEATURE: Image Zoom
     ============================ */
  var AvalnaZoomMod = window.Avalna.pdp.zoom;

  AvalnaZoomMod.init = function () {
    var avalnaZoomOverlay = document.getElementById('avalna-pdp-zoom-overlay');
    if (!avalnaZoomOverlay) return;

    var avalnaZoomImage = avalnaZoomOverlay.querySelector('.avalna-pdp-zoom__image');
    var avalnaZoomClose = avalnaZoomOverlay.querySelector('[data-avalna-zoom-close]');
    var avalnaZoomIn = avalnaZoomOverlay.querySelector('[data-avalna-zoom-in]');
    var avalnaZoomOut = avalnaZoomOverlay.querySelector('[data-avalna-zoom-out]');

    var avalnaZoomScale = 1;
    var avalnaZoomPanX = 0;
    var avalnaZoomPanY = 0;
    var avalnaZoomDragging = false;
    var avalnaZoomStartX = 0;
    var avalnaZoomStartY = 0;
    var avalnaZoomLastFocused = null;

    var AVALNA_ZOOM_MIN = 0.5;
    var AVALNA_ZOOM_MAX = 5;
    var AVALNA_ZOOM_STEP = 0.3;

    function avalnaApplyZoomTransform() {
      if (avalnaZoomImage) {
        avalnaZoomImage.style.transform =
          'translate(' + avalnaZoomPanX + 'px, ' + avalnaZoomPanY + 'px) scale(' + avalnaZoomScale + ')';
      }
    }

    function avalnaResetZoom() {
      avalnaZoomScale = 1;
      avalnaZoomPanX = 0;
      avalnaZoomPanY = 0;
      avalnaApplyZoomTransform();
    }

    function avalnaOpenZoom(avalnaSrc) {
      if (!avalnaZoomImage) return;
      avalnaZoomImage.src = avalnaSrc;
      avalnaResetZoom();
      avalnaZoomOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      avalnaZoomLastFocused = document.activeElement;
      if (avalnaZoomClose) avalnaZoomClose.focus();
    }

    function avalnaCloseZoom() {
      avalnaZoomOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (avalnaZoomLastFocused) avalnaZoomLastFocused.focus();
    }

    /* Expose for external use */
    AvalnaZoomMod.open = avalnaOpenZoom;
    AvalnaZoomMod.close = avalnaCloseZoom;

    /* Bind product images */
    var avalnaProductImages = document.querySelectorAll('[data-avalna-zoom-trigger]');
    avalnaProductImages.forEach(function (avalnaImg) {
      avalnaImg.style.cursor = 'zoom-in';
      avalnaImg.addEventListener('click', function () {
        var avalnaSrc = avalnaImg.getAttribute('data-avalna-zoom-src') ||
                        avalnaImg.getAttribute('src') || '';
        avalnaOpenZoom(avalnaSrc);
      });
    });

    /* Close button */
    if (avalnaZoomClose) {
      avalnaZoomClose.addEventListener('click', avalnaCloseZoom);
    }

    /* ESC key */
    document.addEventListener('keydown', function (avalnaEvt) {
      if (avalnaEvt.key === 'Escape' && avalnaZoomOverlay.getAttribute('aria-hidden') === 'false') {
        avalnaCloseZoom();
      }
    });

    /* Click outside image */
    avalnaZoomOverlay.addEventListener('click', function (avalnaEvt) {
      if (avalnaEvt.target === avalnaZoomOverlay || avalnaEvt.target.classList.contains('avalna-pdp-zoom__image-container')) {
        avalnaCloseZoom();
      }
    });

    /* Zoom in/out buttons */
    if (avalnaZoomIn) {
      avalnaZoomIn.addEventListener('click', function (avalnaEvt) {
        avalnaEvt.stopPropagation();
        avalnaZoomScale = Math.min(avalnaZoomScale + AVALNA_ZOOM_STEP, AVALNA_ZOOM_MAX);
        avalnaApplyZoomTransform();
      });
    }

    if (avalnaZoomOut) {
      avalnaZoomOut.addEventListener('click', function (avalnaEvt) {
        avalnaEvt.stopPropagation();
        avalnaZoomScale = Math.max(avalnaZoomScale - AVALNA_ZOOM_STEP, AVALNA_ZOOM_MIN);
        avalnaApplyZoomTransform();
      });
    }

    /* Mouse wheel zoom */
    avalnaZoomOverlay.addEventListener('wheel', function (avalnaEvt) {
      avalnaEvt.preventDefault();
      var avalnaDelta = avalnaEvt.deltaY > 0 ? -AVALNA_ZOOM_STEP : AVALNA_ZOOM_STEP;
      avalnaZoomScale = Math.min(Math.max(avalnaZoomScale + avalnaDelta, AVALNA_ZOOM_MIN), AVALNA_ZOOM_MAX);
      avalnaApplyZoomTransform();
    }, { passive: false });

    /* Pan / drag support */
    avalnaZoomOverlay.addEventListener('mousedown', function (avalnaEvt) {
      if (avalnaEvt.target === avalnaZoomClose || avalnaEvt.target.closest('[data-avalna-zoom-close]') ||
          avalnaEvt.target.closest('.avalna-pdp-zoom__controls')) return;
      avalnaZoomDragging = true;
      avalnaZoomStartX = avalnaEvt.clientX - avalnaZoomPanX;
      avalnaZoomStartY = avalnaEvt.clientY - avalnaZoomPanY;
    });

    window.addEventListener('mousemove', function (avalnaEvt) {
      if (!avalnaZoomDragging) return;
      avalnaZoomPanX = avalnaEvt.clientX - avalnaZoomStartX;
      avalnaZoomPanY = avalnaEvt.clientY - avalnaZoomStartY;
      avalnaApplyZoomTransform();
    });

    window.addEventListener('mouseup', function () {
      avalnaZoomDragging = false;
    });

    /* Touch pan */
    var avalnaTouchStartX = 0;
    var avalnaTouchStartY = 0;

    avalnaZoomOverlay.addEventListener('touchstart', function (avalnaEvt) {
      if (avalnaEvt.touches.length === 1) {
        avalnaTouchStartX = avalnaEvt.touches[0].clientX - avalnaZoomPanX;
        avalnaTouchStartY = avalnaEvt.touches[0].clientY - avalnaZoomPanY;
      }
    }, { passive: true });

    avalnaZoomOverlay.addEventListener('touchmove', function (avalnaEvt) {
      if (avalnaEvt.touches.length === 1) {
        avalnaZoomPanX = avalnaEvt.touches[0].clientX - avalnaTouchStartX;
        avalnaZoomPanY = avalnaEvt.touches[0].clientY - avalnaTouchStartY;
        avalnaApplyZoomTransform();
      }
    }, { passive: true });
  };

  /* ============================
     FEATURE: Native Video
     ============================ */
  var AvalnaVideoMod = window.Avalna.pdp.video;

  AvalnaVideoMod.init = function () {
    var avalnaVideos = document.querySelectorAll('[data-avalna-video]');
    avalnaVideos.forEach(function (avalnaVideoEl) {
      /* Ensure preload=metadata for performance */
      if (!avalnaVideoEl.getAttribute('preload')) {
        avalnaVideoEl.setAttribute('preload', 'metadata');
      }
    });
  };

  /* ============================
     INIT ON DOM READY
     ============================ */
  function avalnaInitPdp() {
    AvalnaCareMod.init();
    AvalnaSizeGuideMod.init();
    AvalnaZoomMod.init();
    AvalnaVideoMod.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avalnaInitPdp);
  } else {
    avalnaInitPdp();
  }
})();
